module.exports = __webpack_public_path__ + "ui-static/img/empty_media_light.d409c06d.png";